import { render, staticRenderFns } from "./weeks_header_sub_item.vue?vue&type=template&id=594a681e&"
import script from "./weeks_header_sub_item.vue?vue&type=script&lang=js&"
export * from "./weeks_header_sub_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports